import React from 'react';
import { connect } from 'react-redux';


import * as fromData from '../../../store/data/reducer';
import { getUser } from '../../../store/auth/reducer';
import { getUpdateErrorMessage, getPasswordErrorMessage } from '../../../store/auth/reducer'
//import { updatePassword, updateUser} from '../../../store/auth/actions';

const DistributionShare = (props) => {
	

    
//const Iframe = React.createClass({     
//  render: function() {
//    return(         
//        <iframe className="distribution-share-iframe" src="/distribution-share/" />  
//    )
//  }
//});
	return (
		<div className="distribution-share">
        <iframe className="static-react-iframe" src="/distribution-share/"></iframe>
		</div>
	);
};

export default DistributionShare;


// WEBPACK FOOTER //
// ./src/components/routes/Distribution-Share/index.js